import { render } from "./EditCouponPage.vue?vue&type=template&id=4c7c3a70&ts=true"
import script from "./EditCouponPage.vue?vue&type=script&lang=ts"
export * from "./EditCouponPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__